import type { Plan } from "@/lib/gql/__generated__/graphql";

import { useDnD } from "@/hooks/use-dnd/use-dnd";

import { PlanListTable } from "./list";
import { usePlanList } from "../../model/hooks/use-plan-list";
import { useSortPlanList } from "../../model/hooks/use-sort-plan-list/use-sort-plan-list";

type Props = {
	hotelID: string;
};

export const PlanList = ({ hotelID }: Props) => {
	const { plans, secrets, onDeletePlan, inUseBasic, showScConnectedColumn } = usePlanList({ hotelID });
	const { dndItemList, onCancelDnD } = useDnD<Plan>(plans);

	const { onSavePlanListOrder } = useSortPlanList({ hotelID, dndItemList });

	return (
		<PlanListTable
			onDeletePlan={onDeletePlan}
			hotelID={hotelID}
			onSaveSort={onSavePlanListOrder}
			onCancelSort={onCancelDnD}
			dndItemList={dndItemList}
			secretPlans={secrets}
			inUseBasic={inUseBasic}
			showScConnectedColumn={showScConnectedColumn}
		/>
	);
};

PlanList.displayName = "PlanList";
